import en from '@gasbi/localizations/en.json';
import ua from '@gasbi/localizations/ua.json';
import { extendLocale } from '@gasbi/shared/common/utils';

// TODO: move to @gasbi/localizations/
import overridesEn from '@/locales/overrides/en.json';
import overridesUa from '@/locales/overrides/ua.json';

export const LOCALE_NS = 'finance';

export const locales = {
  ua: { [LOCALE_NS]: extendLocale(ua, overridesUa) },
  en: { [LOCALE_NS]: extendLocale(en, overridesEn) },
};

const lng = 'ua';
const supportedLangs = ['ua', 'en', 'uk'];
const fallbackLng = 'uk';
const defaultNS = LOCALE_NS;

export const i18nInstanceOptions = {
  locales,
  lng,
  supportedLangs,
  fallbackLng,
  defaultNS,
};
